module.exports = "/assets/data/c00fe2df24124b9e828ea1506c889556-L31.data.json";